import { useGetApiV1ClassroomdisciplineSharedDisciplines } from '@/shared/api/generated';

import { mapDropdownOptions, useDebouncedFilter } from './useLookupSearch';

/**
 * Busca de disciplinas por texto (debounce + mínimo de 3 caracteres) para o
 * autocomplete de disciplina. Consome o lookup `shared/disciplines` do Kubb.
 *
 * @param filter - Texto digitado no campo (default `''`).
 * @returns `{ options, isLoading, isQuerySuccess }`.
 */
export function useDisciplineSearchDropdown(filter = '') {
  const { debouncedFilter, isReady } = useDebouncedFilter(filter);

  const { data, isLoading, isSuccess } = useGetApiV1ClassroomdisciplineSharedDisciplines(
    isReady ? { Search: debouncedFilter } : undefined,
    { query: { enabled: isReady } },
  );

  return { options: mapDropdownOptions(data), isLoading, isQuerySuccess: isSuccess } as const;
}
